import store from "@/store";
import translate from "../languages/index"
let lang = localStorage.getItem('language')
export default {
  install(Vue) {
    Date.prototype.add = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    }
    Date.prototype.substractDays = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() - days);
      return date;
    }
    // Apply Gtm
    let gmt = new Date();
    gmt.getTimezoneOffset() / 60;
    let hour = String(gmt);
    hour = Number(hour.slice(28, 31))
    let hoursDay = 23 + hour

    Vue.prototype.$date = {
      format: function (date, format) {
        if (!date) return null;
        const [year, month, day] = date.split("-");

        switch (format) {
          case 'DD-MM-YYYY':
            return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
          case 'DD/MM/YYYY':
            return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
          case 'DD/MM':
            //? Ex. 13/04/2023 --> 13/04
            return `${day.padStart(2, '0')}/${month.padStart(2, '0')}`
          case 'YYYY-MM-DD HR:MM:SS':
            //? Ex. 2023-04-10T00:00:00.000 --> 2023-04-10 00:00:00
            return date.replace("T", " ").replace(".000", "")
          case 'YYYY-MM-DD':
            //? Ex. 2023-04-10 00:00:00 --> 2023-04-10
            return date.split(" ")[0];
          default:
            return date
        }
      },

      formatRange: function (range) {
        var data_inicio_br = new Date(range.data_inicio).toLocaleString();
        var data_final_br = new Date(range.data_final).toLocaleString();
        return `${data_inicio_br} - ${data_final_br}`;
        // Output: 01/04/2021 00:00:00 - 26/04/2021 23:59:59
      },

      buildRangeUi: async function (date_start, date_final) {
        let dt_start = new Date(date_start).toLocaleDateString();
        let dt_end = new Date(date_final).toLocaleDateString();
        let tm_start = new Date(date_start).toLocaleTimeString();
        let tm_end = new Date(date_final).toLocaleTimeString();
        // console.log(dt_start)
        // console.log(dt_end)
        // reset (Importante!)
        await store.commit("SetDateStartBr", "");
        await store.commit("SetDateEndBr", "");
        await store.commit("SetTimeStart", "");
        await store.commit("SetTimeEnd", "");
        // set
        store.commit("SetDateStartBr", dt_start);
        store.commit("SetDateEndBr", dt_end);
        store.commit("SetTimeStart", tm_start);
        store.commit("SetTimeEnd", tm_end);
        store.commit("setDisabledRange", false);

        // Range UI - Normalmente é recuperado nas views para Impressão e acima dos Resumos
        // Mas pode ter outras utilizadades de exibição nas páginas;
        let rangeUi = `${translate[lang].from} ${dt_start} ${tm_start} ${translate[lang].until} ${dt_end} ${tm_end}`;
        store.commit("setRangeUI", rangeUi);
      },

      get: {
        // Função original "Apuração Semanal"
        weekly_deal: function () {
          return {
            weekly_deal: 1,
          };
        },

        // Function criada para inclusão da "Apuração semanal" e "Apuração Atual" no mesmo
        // escopo de código
        allDeals: function (value) {
          return {
            weekly_deal: value,
          }
        },

        onlyDate: function (val) {
          var dateEvent = new Date(val.replace(" ", "T"))
            .toLocaleDateString()
            .slice(0, -5);
          var today = new Date().toLocaleDateString().slice(0, -5);
          if (dateEvent == today) return "HOJE";
          return dateEvent;
        },

        onlyHour: function (val) {
          if (val.lastIndexOf("Z") != -1) {
            return new Date(`${val.slice(0, -5)}}${hour}`)
              .toLocaleTimeString()
              .slice(0, -3);
          }
          return new Date(val.replace(" ", "T")).toLocaleTimeString().slice(0, hour);
        },

        today: function () {
          return {
            data_inicio: new Date(new Date().setHours(hour, 0, 0)).toISOString().slice(0, -1),
            data_final: new Date(new Date().setHours(hoursDay, 59, 59)).toISOString().slice(0, -1),
          }
        },

        yesterday: function () {
          return {
            data_inicio: new Date(new Date().setHours(hour, 0, 0)).substractDays(1).toISOString().slice(0, -1),
            data_final: new Date(new Date().setHours(hoursDay, 59, 59)).substractDays(1).toISOString().slice(0, -1),
          }
        },

        currentWeek: function () {
          let curr = new Date
          let week = [];
          for (let i = 1; i <= 7; i++) {
            let first = curr.getDate() - curr.getDay() + i;
            // Tratamento de data para domingo 
            if (curr.getDay() == 0) {
              first = first - 7
            }
            let day = new Date(curr.setDate(first)).toISOString();
            // console.log(day)

            let dayHandle = new Date(new Date(day).setHours(hour, 0, 0)).toISOString();
            week.push(dayHandle)
          }

          const startWeek = new Date(new Date(week[0]).setHours(hour, 0, 0)).add(1).toISOString().slice(0, -1);
          const endWeek = new Date(new Date(week[week.length - 1]).setHours(hoursDay, 59, 59)).add(1).toISOString().slice(0, -1);
          return {
            data_inicio: startWeek,
            data_final: endWeek,
          }
        },

        lastWeek: function () {
          let curr = new Date
          let week = []

          for (let i = 1; i <= 7; i++) {
            let first = curr.getDate() - curr.getDay() + i
            // Tratamento de data para domingo
            if (curr.getDay() == 0) {
              first = first - 7
            }
            let day = new Date(curr.setDate(first)).toISOString();

            let dayHandle = new Date(new Date(day).setHours(hour, 0, 0)).toISOString();
            // console.log(dayHandle);
            week.push(dayHandle)
          }

          const startWeek = new Date(new Date(week[0]).setHours(hour, 0, 0)).substractDays(6).toISOString().slice(0, -1);
          const endWeek = new Date(new Date(week[0]).setHours(hoursDay, 59, 59)).toISOString().slice(0, -1);

          return {
            data_inicio: startWeek,
            data_final: endWeek,
          }
        },

        lastSevenDays: function () {
          return {
            data_inicio: new Date(new Date().setHours(hour, 0, 0)).substractDays(7).toISOString().slice(0, -1),
            data_final: new Date(new Date().setHours(hoursDay, 59, 59)).toISOString().slice(0, -1),
          }
        },

        currentMonth: function () {
          const date = new Date();
          const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          return {
            data_inicio: new Date(new Date(firstDay).setHours(hour, 0, 0)).toISOString().slice(0, -1),
            data_final: new Date(new Date().setHours(hoursDay, 59, 59)).toISOString().slice(0, -1),
          }
        },

        halfMonth: function () {
          return {
            data_inicio: new Date(new Date().setHours(hour, 0, 0)).substractDays(15).toISOString().slice(0, -1),
            data_final: new Date(new Date().setHours(hoursDay, 59, 59)).toISOString().slice(0, -1),
          }
        },

        lastMonth: function () {
          var date = new Date();
          var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
          var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);

          // Para enviar o GMT padrão do local
          // Resolveu uma divergência do GMT do paraguai

          firstDay.getTimezoneOffset() / 60;
          let hourLastMonth = String(firstDay);
          let hourGMT = Number(hourLastMonth.slice(28, 31))
          let hourDayGMT = 23 + hourGMT


          return {
            data_inicio: new Date(new Date(firstDay).setHours(hourGMT, 0, 0)).toISOString().slice(0, -1),
            data_final: new Date(new Date(lastDay).setHours(hourDayGMT, 59, 59)).toISOString().slice(0, -1),
          }
        },

        localeDateTime: function () {
          let date = (new Date()).toLocaleDateString();
          let time = (new Date()).toLocaleTimeString();
          return `${date} ${time}`;
        },

        daysBetweenTwoDates: function (dateStart, dateFinal) {
          var getDaysArray = function(date_start, date_final) {
            for(
              var daysArray = [],
              date = new Date(date_start);
              date <= new Date(date_final);
              date.setDate(date.getDate() + 1)
            ){
              daysArray.push(new Date(date));
            }
            return daysArray;
          };

          var daysArray = getDaysArray(new Date(dateStart), new Date(dateFinal));
          return daysArray.map((day) => day.toISOString().slice(0,10));
        },
      }
    }
  }
}